import React, { PureComponent } from "react";
import { connect } from "react-redux";

import {
  RightPanelContainer,
  Wrapper,
  Button,
  Copy,
  Scroll
} from "app/NativeComponents/common";
import {
  appRedirect,
  toggleConversationLeadView,
  setStatusModal,
  updateLead,
  selectActiveProperty
} from "app/NativeActions";
import LeadInfoTitle from "./LeadInfoTitle";
import AssignLead from "./AssignLead";
import PropertyInfo from "app/DealMachineCore/components/Property/PropertyInfo";
import LocationMap from "app/DealMachineCore/components/Property/LocationMap";

class ConversationLeadInfo extends PureComponent {
  constructor(props) {
    super(props);

    this.handleBack = this.handleBack.bind(this);
    this.toggleAssignLead = this.toggleAssignLead.bind(this);
  }

  componentDidMount() {
    if (
      !this.props.toggle_conversation_lead_view ||
      !this.props.active_conversation ||
      this.props.active_conversation.length == 0
    ) {
      this.handleBack();
    }
  }

  componentWillUnmount() {
    this.props.toggleConversationLeadView({ show: false, new_property: false });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.assign_new_property !== this.props.assign_new_property) {
      this.toggleAssignLead(this.props.assign_new_property);
    }
  }

  handleBack() {
    this.props.toggleConversationLeadView({ show: false, new_property: false });

    if (this.props.assign_new_property) {
      this.props.toggleConversationLeadView({
        show: false,
        new_property: false
      });
    } else {
      this.props.appRedirect({
        redirect: "goBack",
        payload: { remove: "lead" }
      });
    }
  }

  toggleAssignLead(toggle) {
    this.props.toggleConversationLeadView({ show: true, new_property: toggle });
  }

  render() {
    const {
      toggle_conversation_lead_view,
      active_conversation,
      colors
    } = this.props;

    if (
      toggle_conversation_lead_view &&
      active_conversation &&
      active_conversation != "conversation_settings" &&
      active_conversation != "manage_phone_numbers" &&
      active_conversation != "manage_saved_replies" &&
      active_conversation.length > 0
    ) {
      const conversation_info = active_conversation[0];

      if (!conversation_info.property || this.props.assign_new_property) {
        return (
          <RightPanelContainer
            size="small"
            style={{
              backgroundColor: colors.card_color,
              borderLeftWidth: 1,
              borderLeftStyle: "solid",
              borderLeftColor: colors.border_color
            }}
          >
            <Wrapper style={{ height: "100%" }}>
              <LeadInfoTitle
                {...this.props}
                conversation_info={conversation_info}
                handleBack={this.handleBack}
                assign_new_property={this.props.assign_new_property}
                colors={colors}
              />
              <Scroll
                style={{
                  flex: 1,
                  backgroundColor: this.props.background_color
                }}
              >
                <AssignLead
                  conversation_info={conversation_info}
                  assign_new_property={this.props.assign_new_property}
                  toggleAssignLead={this.toggleAssignLead}
                  {...this.props}
                />
              </Scroll>
            </Wrapper>
          </RightPanelContainer>
        );
      }

      return (
        <RightPanelContainer
          size="small"
          style={{
            backgroundColor: colors.card_color,
            borderLeftWidth: 1,
            borderLeftStyle: "solid",
            borderLeftColor: colors.border_color
          }}
        >
          <Wrapper style={{ height: "100%" }}>
            <LeadInfoTitle
              {...this.props}
              conversation_info={conversation_info}
              handleBack={this.handleBack}
              assign_new_property={this.props.assign_new_property}
              colors={colors}
            />
            <Scroll
              style={{ flex: 1, backgroundColor: this.props.background_color }}
            >
              <PropertyInfo
                {...this.props}
                property={conversation_info.property}
              />

              <LocationMap
                {...this.props}
                property={conversation_info.property}
              />
            </Scroll>
          </Wrapper>
        </RightPanelContainer>
      );
    }

    return <Wrapper />;
  }
}

const mapStateToProps = ({ auth, native, settings, message }) => {
  const { token, user } = auth;
  const { device, isMobile, platform, isIphoneX } = native;
  const { colors } = settings;

  const {
    active_conversation,
    active_conversation_loading,
    set_to_phone_number,
    toggle_conversation_lead_view,
    assign_new_property
  } = message;

  return {
    token,
    user,
    device,
    isMobile,
    platform,
    isIphoneX,
    colors,

    active_conversation,
    active_conversation_loading,
    set_to_phone_number,
    toggle_conversation_lead_view,
    assign_new_property
  };
};

export default connect(mapStateToProps, {
  appRedirect,
  toggleConversationLeadView,
  setStatusModal,
  updateLead,
  selectActiveProperty
})(ConversationLeadInfo);
